// @flow

import React from 'react';

// Helpers
import { themePropertyFetcher } from '../tools/helpers';

// Theme
import defaultTheme from '../themes/defaultTheme';
import legacyTheme from '../themes/legacyTheme';

// Styles
import { StyledSVG, StyledCaret, StyledTriangle } from './styles';

// TODO: Replace image for StyledSVG
export function Caret(props: Object) {
    return <StyledCaret {...props} />;
}

export function Triangle(props: Object) {
    return <StyledTriangle {...props} />;
}

export function Checkmark(props: {
    clickable?: ?boolean,
    fill?: ?string,
    margin?: ?string,
    width?: ?string,
}) {
    const styles = {
        margin: props.margin,
        cursor: props.clickable ? 'pointer' : 'default',
    };
    return (
        <StyledSVG width={props.width} height={props.width} viewBox="0 0 14 12" style={styles}>
            <g transform="translate(-971.000000, -629.000000)" fill={props.fill}>
                <g transform="translate(958.000000, 602.000000)">
                    <g transform="translate(0.000000, 13.000000)">
                        <polygon points="24.5392646 14.6666667 26.6666667 16.8682717 18.4869118 25.3333333 13.3333333 20 15.4607354 17.798395 18.4869118 20.9301233 24.5392646 14.6666667" />
                    </g>
                </g>
            </g>
        </StyledSVG>
    );
}

Checkmark.defaultProps = {
    clickable: false,
    fill: legacyTheme.defaultSuccessColor,
    margin: 'auto',
    width: '14px',
};

export function Close(props: {
    clickable?: ?boolean,
    fill?: ?string,
    margin?: ?string,
    strokeWidth?: ?number,
    width?: ?string,
    style?: ?Object,
}) {
    const styles = {
        margin: props.margin,
        cursor: props.clickable ? 'pointer' : 'default',
        ...props.style,
    };

    return (
        <StyledSVG viewBox="0 0 12 12" width={props.width} height={props.width} style={styles}>
            <g>
                <path
                    stroke={props.fill}
                    strokeWidth={props.strokeWidth}
                    fill={props.fill}
                    d="M10,2.73l-0.73,-0.73l-3.27,3.27l-3.27,-3.27l-0.73,0.73l3.27,3.27l-3.27,3.27l0.73,0.73l3.27,-3.27l3.27,3.27l0.73,-0.73l-3.27,-3.27z"
                />
            </g>
        </StyledSVG>
    );
}

Close.defaultProps = {
    clickable: false,
    fill: legacyTheme.defaultWarningColor,
    margin: 'auto',
    strokeWidth: 2,
    style: {},
    width: '14px',
};

export function Pencil(props: { fill?: ?string, margin?: ?string, width?: ?string }) {
    const styles = {
        margin: props.margin,
    };

    return (
        <StyledSVG viewBox="0 0 16 17" width={props.width} height={props.width} style={styles}>
            <g>
                <path
                    fill={props.fill}
                    d="M9.95,3.61l-7.43,7.43c-0.18,0.18 -0.18,0.47 0,0.64l2.12,2.12c0.18,0.18 0.47,0.18 0.64,0l7.43,-7.43c0.18,-0.18 0.18,-0.47 0,-0.64l-2.12,-2.12c-0.18,-0.18 -0.47,-0.18 -0.64,0z"
                />
                <path
                    fill={props.fill}
                    d="M12.03,1.51l-0.94,0.94c-0.2,0.2 -0.2,0.51 0,0.71l2.04,2.04c0.2,0.2 0.51,0.2 0.71,0l0.94,-0.94c0.2,-0.2 0.2,-0.51 0,-0.71l-2.04,-2.04c-0.2,-0.2 -0.51,-0.2 -0.71,0z"
                />
                <path
                    fill={props.fill}
                    d="M1.28,12.4l-0.31,2.35c-0.04,0.27 0.16,0.53 0.43,0.56c0.04,0.01 0.09,0.01 0.13,0l2.37,-0.29c0.27,-0.03 0.47,-0.28 0.43,-0.56c-0.01,-0.11 -0.06,-0.21 -0.14,-0.29l-2.05,-2.05c-0.2,-0.2 -0.51,-0.2 -0.71,0c-0.08,0.08 -0.13,0.18 -0.14,0.29z"
                />
            </g>
        </StyledSVG>
    );
}

Pencil.defaultProps = {
    fill: legacyTheme.defaultIconColor,
    margin: 'auto',
    width: '16px',
};

export function Trash(props: { fill?: ?string, margin?: ?string, width?: ?string }) {
    const styles = {
        margin: props.margin,
    };

    return (
        <StyledSVG viewBox="0 0 14 17" width={props.width} height={props.width} style={styles}>
            <g>
                <path
                    fill={props.fill}
                    d="M1.66,5.14c0,-0.28 0.22,-0.5 0.5,-0.5h9.68c0.02,0 0.04,0 0.05,0c0.27,0.03 0.47,0.28 0.44,0.55l-1.09,9.93c-0.03,0.25 -0.24,0.45 -0.5,0.45h-7.5c-0.26,0 -0.47,-0.19 -0.5,-0.45l-1.09,-9.93c0,-0.02 0,-0.04 0,-0.05zM13,2.71v0.21c0,0.28 -0.22,0.5 -0.5,0.5h-11c-0.28,0 -0.5,-0.22 -0.5,-0.5v-0.21c0,-0.28 0.22,-0.5 0.5,-0.5h2.93c0.54,0 0.98,-0.67 0.98,-1.21h3.19c0,0.55 0.44,1.21 0.98,1.21h2.93c0.28,0 0.5,0.22 0.5,0.5z"
                />
            </g>
        </StyledSVG>
    );
}

Trash.defaultProps = {
    fill: legacyTheme.defaultIconColor,
    margin: 'auto',
    width: '14px',
};

export function NavigationChevron(props: {
    fill?: ?string,
    height?: ?string,
    margin?: ?string,
    width?: ?string,
}) {
    const styles = {
        margin: props.margin,
    };
    return (
        <StyledSVG viewBox="0 0 5 10" width={props.width} height={props.height} style={styles}>
            <g stroke="none" strokeWidth="1" fill={props.fill} fillRule="evenodd">
                <g
                    transform="translate(-36.000000, -172.000000)"
                    fill={props.fill}
                    fillRule="nonzero"
                >
                    <g transform="translate(0.000000, 59.000000)">
                        <g transform="translate(39.000000, 118.000000) rotate(90.000000) translate(-39.000000, -118.000000) translate(24.000000, 103.000000)">
                            <path d="M14.7726293,17.9111325 C14.8331232,17.96803 14.915211,18 15.00081,18 C15.0864089,18 15.1684967,17.96803 15.2289906,17.9111325 L19.9054845,13.5175506 C20.0315052,13.3991538 20.0315052,13.2071945 19.9054845,13.0887977 C19.7794638,12.9704008 19.5751439,12.9704008 19.4491232,13.0887976 L15.0000037,17.2687605 L10.5508842,13.0903127 C10.4693631,13.0137233 10.3505435,12.9838118 10.2391836,13.0118454 C10.1278237,13.0398791 10.0408417,13.1215989 10.011003,13.2262219 C9.98116416,13.3308449 10.0130018,13.4424763 10.0945229,13.5190657 L14.7726293,17.9111325 Z" />
                        </g>
                    </g>
                </g>
            </g>
        </StyledSVG>
    );
}

NavigationChevron.defaultProps = {
    fill: 'useCurrent',
    height: '10px',
    margin: 'auto',
    width: '5px',
};

export function InfoIcon(props: {
    fill?: ?string,
    height?: ?string,
    margin?: ?string,
    width?: ?string,
}) {
    const styles = {
        margin: props.margin,
    };
    return (
        <StyledSVG viewBox="0 0 20 20" width={props.width} height={props.height} style={styles}>
            <g strokeWidth="1" fill={props.fill}>
                <g transform="translate(-374.000000, -1625.000000)" fill={props.fill}>
                    <g transform="translate(369.000000, 1620.000000)">
                        <path d="M7.92875989,7.92875989 C4.0237467,11.8337731 4.0237467,18.1662269 7.92875989,22.0712401 C11.8337731,25.9762533 18.1662269,25.9762533 22.0712401,22.0712401 C25.9762533,18.1662269 25.9762533,11.8337731 22.0712401,7.92875989 C18.1662269,4.0237467 11.8337731,4.0237467 7.92875989,7.92875989 Z M15.4010554,9.19525066 C16.2453826,9.19525066 16.9208443,9.89182058 16.9208443,10.7361478 C16.9208443,11.5804749 16.2242744,12.2770449 15.4010554,12.2770449 C14.5567282,12.2770449 13.8601583,11.5804749 13.8601583,10.7150396 C13.8601583,9.8707124 14.5567282,9.19525066 15.4010554,9.19525066 Z M17.5751979,19.5171504 C17.5329815,19.6437995 17.4485488,19.7915567 17.3641161,19.8759894 C16.8153034,20.4459103 16.1398417,20.7836412 15.3377309,20.7836412 C14.9577836,20.7836412 14.5989446,20.7836412 14.2189974,20.7203166 C13.6068602,20.6358839 12.8258575,19.8759894 12.9313984,19.0738786 C13.0158311,18.525066 13.1002639,17.9762533 13.1846966,17.4274406 C13.353562,16.4775726 13.5224274,15.5065963 13.6912929,14.5567282 C13.6912929,14.4934037 13.7124011,14.4300792 13.7124011,14.3667546 C13.7124011,13.9656992 13.585752,13.817942 13.1846966,13.7757256 C13.0158311,13.7546174 12.8469657,13.7335092 12.6781003,13.6912929 C12.4881266,13.6279683 12.3825858,13.4591029 12.4036939,13.3113456 C12.4248021,13.1424802 12.530343,13.0369393 12.7414248,12.994723 C12.8469657,12.9736148 12.9736148,12.9736148 13.1002639,12.9736148 C13.5646438,12.9736148 14.0290237,12.9736148 14.5145119,12.9736148 C15.0211082,12.9736148 15.5065963,12.9736148 16.0131926,12.9736148 C16.3720317,12.9736148 16.5831135,13.1424802 16.5831135,13.5013193 C16.5831135,13.7968338 16.5408971,14.0923483 16.4775726,14.3878628 C16.2875989,15.4854881 16.0765172,16.5620053 15.8865435,17.6596306 C15.823219,18.0184697 15.7387863,18.3773087 15.6965699,18.7361478 C15.6754617,18.9050132 15.6965699,19.0949868 15.7387863,19.2638522 C15.8021108,19.4960422 15.9709763,19.6226913 16.2031662,19.6015831 C16.3931398,19.5804749 16.5831135,19.5171504 16.7730871,19.4327177 C16.9208443,19.3693931 17.0474934,19.2638522 17.1952507,19.2216359 C17.4485488,19.1372032 17.6385224,19.2849604 17.5751979,19.5171504 Z" />
                    </g>
                </g>
            </g>
        </StyledSVG>
    );
}

InfoIcon.defaultProps = {
    fill: legacyTheme.defaultIconColor,
    height: '20px',
    margin: 'auto',
    width: '20px',
};

export function Dot(props: { fill?: ?string, width?: ?string, margin?: ?string }) {
    const styles = {
        flexShrink: 0,
        margin: props.margin,
    };
    return (
        <StyledSVG viewBox="0 0 12 12" width={props.width} height={props.width} style={styles}>
            <circle cx="6" cy="6" r="3" stroke={props.fill} fill={props.fill} />
        </StyledSVG>
    );
}

Dot.defaultProps = {
    fill: legacyTheme.black,
    margin: 'auto',
    width: '16px',
};

export function GearIcon(props: {
    fill?: ?string,
    height?: ?string,
    margin?: ?string,
    width?: ?string,
}) {
    const styles = {
        margin: props.margin,
    };
    return (
        <StyledSVG viewBox="0 0 30 30" width={props.width} height={props.height} style={styles}>
            <g stroke="none" strokeWidth="1" fill={props.fill} fillRule="evenodd">
                <path
                    d="M27.0486481,13.1068294 L24.4731269,12.6771615 C24.2859381,11.9118437 24.0130041,11.1802736 23.6575457,10.497947 L25.3063215,8.45357863 C25.6569921,8.02153127 25.6410618,7.39988103 25.271356,6.98289395 L24.2470263,5.83004222 C23.8757246,5.41349042 23.2599835,5.3253921 22.7903141,5.62212904 L20.5877486,7.00674666 C19.6189865,6.32987537 18.521621,5.83004222 17.3378429,5.54000842 L16.9069402,2.95059704 C16.8165232,2.40230402 16.342066,2 15.7851134,2 L14.2414662,2 C13.6856453,2 13.2095921,2.40230402 13.1211773,2.95059704 L12.6879242,5.54082092 C11.7092093,5.78045065 10.7915752,6.16725912 9.95414419,6.67669718 L7.8594639,5.18175355 C7.40801718,4.85921971 6.78795258,4.9096528 6.39398857,5.30278717 L5.30344209,6.39414999 C4.91031957,6.78812588 4.85988799,7.40820916 5.18325361,7.85966949 L6.68163424,9.95841736 C6.17699933,10.7895478 5.79417785,11.7019863 5.55458435,12.6720253 L2.95051036,13.1068584 C2.40307536,13.1972781 2,13.6717787 2,14.228777 L2,15.771252 C2,16.3281923 2.40307536,16.8027509 2.95051036,16.8931706 L5.55458435,17.3280037 C5.75134873,18.1262278 6.03699223,18.8887019 6.41665086,19.5956647 L4.77539045,21.628484 C4.42590952,22.0601251 4.44059213,22.6821816 4.81029792,23.0987914 L5.83384411,24.2516722 C6.20517485,24.6690074 6.8212351,24.7555098 7.29096254,24.4595273 L9.5252727,23.055932 C10.4706761,23.7025957 11.5402142,24.1778797 12.6879242,24.4595273 L13.1211773,27.0493739 C13.2096211,27.597696 13.6856453,28 14.2414662,28 L15.7851134,28 C16.342066,28 16.8165232,27.597725 16.9069402,27.049403 L17.3385683,24.4595563 C18.305067,24.2231476 19.2110653,23.8430713 20.041039,23.3423676 L22.2230025,24.9007733 C22.6736367,25.2244679 23.2941656,25.1736866 23.6877233,24.7793044 L24.7787051,23.6883188 C25.1713633,23.2955327 25.2245515,22.6757976 24.8984583,22.2235248 L23.3450034,20.045471 C23.8510891,19.2115549 24.2359418,18.2974914 24.4740264,17.3231287 L27.0495187,16.8930836 C27.5985496,16.8026638 28,16.3281343 28,15.7711649 L28,14.22869 C27.9991875,13.6717787 27.5977371,13.1972781 27.0486481,13.1068294 Z M15.0000298,20 C12.23918,20 10,17.7604167 10,15 C10,12.2391667 12.23918,10 15.0000298,10 C17.7604033,10 20,12.2391667 20,15 C20,17.7604167 17.7604033,20 15.0000298,20 Z"
                    fill={props.fill}
                    fillRule="nonzero"
                />
            </g>
        </StyledSVG>
    );
}

GearIcon.defaultProps = {
    fill: 'currentColor',
    height: '30px',
    margin: 'auto',
    width: '30px',
};

export function CalculatorIcon(props: {
    fill?: ?string,
    height?: ?string,
    margin?: ?string,
    width?: ?string,
}) {
    const styles = {
        margin: props.margin,
    };
    return (
        <StyledSVG width={props.width} height={props.height} style={styles} viewBox="0 0 11 14">
            <g stroke="none" strokeWidth="1" fill="none">
                <g transform="translate(-732.000000, -92.000000)">
                    <g transform="translate(400.000000, 82.000000)">
                        <g transform="translate(322.000000, 2.000000)">
                            <g transform="translate(10.000000, 8.000000)">
                                <rect
                                    stroke={props.fill}
                                    x="0.5"
                                    y="0.5"
                                    width="10"
                                    height="13"
                                    rx="2"
                                />
                                <rect fill={props.fill} x="2" y="2" width="7" height="3" />
                                <path
                                    d="M2,8.5 L2,6 L5,6 L5,8.5 L2,8.5 Z M2,9.5 L5,9.5 L5,12 L2,12 L2,9.5 Z M9,8.5 L6,8.5 L6,6 L9,6 L9,8.5 Z M9,9.5 L9,12 L6,12 L6,9.5 L9,9.5 Z"
                                    fill={props.fill}
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </StyledSVG>
    );
}

CalculatorIcon.defaultProps = {
    fill: legacyTheme.defaultIconColor,
    height: '14px',
    margin: 'auto',
    width: '11px',
};

export function FloppyDiskIcon(props: {
    fill?: ?string,
    height?: ?string,
    margin?: ?string,
    width?: ?string,
}) {
    const styles = {
        margin: props.margin,
    };
    return (
        <StyledSVG width={props.width} height={props.height} style={styles} viewBox="0 0 30 30">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <path
                    d="M18.003,6 L21,6 L21,11 L18.003,11 L18.003,6 Z M27,7.41421356 L27,26 C27,26.5522847 26.5522847,27 26,27 L4,27 C3.44771525,27 3,26.5522847 3,26 L3,4 C3,3.44771525 3.44771525,3 4,3 L22.5857864,3 C22.8510029,3 23.1053568,3.10535684 23.2928932,3.29289322 L26.7071068,6.70710678 C26.8946432,6.89464316 27,7.14899707 27,7.41421356 Z M9,12 L21,12 C21.5522847,12 22,11.5522847 22,11 L22,6 C22,5.44771525 21.5522847,5 21,5 L9,5 C8.44771525,5 8,5.44771525 8,6 L8,11 C8,11.5522847 8.44771525,12 9,12 Z M23,16 L7,16 C6.44771525,16 6,16.4477153 6,17 L6,24 C6,24.5522847 6.44771525,25 7,25 L23,25 C23.5522847,25 24,24.5522847 24,24 L24,17 C24,16.4477153 23.5522847,16 23,16 Z"
                    fill={props.fill}
                    fillRule="nonzero"
                />
            </g>
        </StyledSVG>
    );
}

FloppyDiskIcon.defaultProps = {
    fill: legacyTheme.defaultIconColor,
    height: '14px',
    margin: 'auto',
    width: '11px',
};

export function NotificationBell(props: {
    fill?: ?string,
    margin?: ?string,
    width?: ?string,
    showDot?: ?boolean,
    dotFill?: ?string,
    exclamationBell?: ?boolean,
}) {
    const styles = {
        margin: props.margin,
    };

    const bellPathWithDot =
        'M13.415279,21.7142857 C13.2037768,23 11.9951931,24 10.5448927,24 C9.09459227,24 7.88600858,23 7.67450644,21.7142857 L7.67450644,21.7142857 Z M10.6053219,0 C11.603352,0 12.4568985,0.68313029 12.6285187,1.60216169 C11.6401142,2.70567555 11.04,4.16275568 11.04,5.76 C11.04,9.20625684 13.8337432,12 17.28,12 C17.5756878,12 17.8665721,11.9794336 18.1513004,11.9396533 C18.4693403,16.9331044 20.1388461,18.0251939 21.12,18.2571429 L21.12,18.2571429 L21.12,20.8571429 L0,20.8571429 L0,18.2571429 C1.08772532,17.9714286 3.02145923,16.6857143 3.02145923,10.1714286 C3.02145923,5.22857143 6.49613734,3.51428571 8.82266094,2.91428571 C8.64137339,2.62857143 8.55072961,2.28571429 8.55072961,1.94285714 C8.55072961,0.885714286 9.48738197,0 10.6053219,0 Z';
    const bellPathWithoutDot =
        'M13.415279,21.7142857 C13.2037768,23 11.9951931,24 10.5448927,24 C9.09459227,24 7.88600858,23 7.67450644,21.7142857 L7.67450644,21.7142857 Z M10.6053219,0 C11.7232618,0 12.6599142,0.857142857 12.6599142,1.94285714 C12.6599142,2.31428571 12.5692704,2.62857143 12.3879828,2.91428571 C14.6238627,3.51428571 18.0985408,5.22857143 18.0985408,10.1714286 C18.0985408,16.6857143 20.0322747,18 21.12,18.2571429 L21.12,18.2571429 L21.12,20.8571429 L0,20.8571429 L0,18.2571429 C1.08772532,17.9714286 3.02145923,16.6857143 3.02145923,10.1714286 C3.02145923,5.22857143 6.49613734,3.51428571 8.82266094,2.91428571 C8.64137339,2.62857143 8.55072961,2.28571429 8.55072961,1.94285714 C8.55072961,0.885714286 9.48738197,0 10.6053219,0 Z';

    const bellPath = props.showDot ? bellPathWithDot : bellPathWithoutDot;
    if(props.exclamationBell){
        return (
            <svg  viewBox="0 0 24 24"width={props.width} height={props.width} style={styles}>
                <g clip-path="url(#clip0_6_3136)">
                <path d="M18 16V11C18 7.93 16.36 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.63 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16ZM13 16H11V14H13V16ZM13 12H11V8H13V12ZM12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.89 22 12 22Z" fill={props.fill} />
                    </g>
                    <defs>
                    <clipPath id="clip0_6_3136">
                    <rect width="24" height="24" fill={props.dotFill ?? 'white'}/>
                    </clipPath>
                </defs>
            </svg>
            )
        };
    return (
        <StyledSVG viewBox="0 0 24 24" width={props.width} height={props.width} style={styles}>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(1.000000, 0.000000)">
                    <path d={bellPath} fill={props.fill} fillRule="nonzero" />
                    {props.showDot && (
                        <g transform="translate(12.480000, 0.960000)" fill={props.dotFill}>
                            <circle cx="4.8" cy="4.8" r="4.8" />
                        </g>
                    )}
                </g>
            </g>
        </StyledSVG>
    );
}

NotificationBell.defaultProps = {
    fill: legacyTheme.defaultIconColor,
    dotFill: legacyTheme.notificationDotColor,
    showDot: false,
    margin: 'auto',
    width: '14px',
};

export class PlusDotIcon extends React.PureComponent<{
    backgroundColor?: ?string,
    color?: ?string,
    margin?: ?string,
    theme?: ?Object,
    width?: ?number,
}> {
    static defaultProps = {
        backgroundColor: null,
        color: null,
        margin: null,
        theme: defaultTheme,
        width: null,
    };

    render() {
        const backgroundColor =
            this.props.backgroundColor ||
            themePropertyFetcher(this.props.theme, ['icons', 'plusDotIcon', 'backgroundColor']);
        const color =
            this.props.color ||
            themePropertyFetcher(this.props.theme, ['icons', 'plusDotIcon', 'color']);
        const size =
            this.props.width ||
            themePropertyFetcher(this.props.theme, ['icons', 'plusDotIcon', 'size']);

        const styles = {
            margin:
                this.props.margin ||
                themePropertyFetcher(this.props.theme, ['icons', 'plusDotIcon', 'margin']),
        };

        return (
            <StyledSVG
                width={`${size}px`}
                height={`${size}px`}
                viewBox={`0 0 ${size} ${size}`}
                style={styles}
            >
                <g>
                    <g>
                        <path
                            fill={backgroundColor}
                            d="M3.22 3.22C-1.07 7.52 -1.07 14.48 3.22 18.78C7.52 23.07 14.48 23.07 18.78 18.78C23.07 14.48 23.07 7.52 18.78 3.22C14.48 -1.07 7.52 -1.07 3.22 3.22Z"
                        />
                    </g>
                    <path
                        fill={color}
                        d="M5 11.78L5 9.9L9.87 9.9L9.87 5L11.78 5L11.78 9.9L16.64 9.9L16.64 11.78L11.78 11.78L11.78 16.66L9.87 16.66L9.87 11.78L5 11.78Z"
                    />
                </g>
            </StyledSVG>
        );
    }
}
